import Link from 'next/link';

import Badge from '@core/components/badge/Badge';

import UseSlugRoute from 'hooks/use-slugroute';

import { Updated } from 'constants/content-status';

import StarIcon from 'assets/icons/star-rating.svg';

import classes from './LectureCard.module.scss';

const LectureCard = ({ card }) => {
	const slugRoute = UseSlugRoute();

	return (
		<Link
			href={slugRoute(`/courses/${card.id}`, card.slug)}
			className={classes['lecture-container']}>
			<img src={card.image} alt="" />
			<div className={classes['lecture-bottom']}>
				<div className={`${classes['lecture-status']} d-flex flex-row gap-1 align-items-center`}>
					{card.has_been_updated && <Badge status={Updated} />}
					<Badge status={card.status} />
				</div>
				<p>{card.title}</p>
				<div className={classes['lecture-info']}>
					<div className={classes['rating']}>
						<StarIcon /> {card.rate_average}
					</div>
					<span className={classes['dot']} />
					<div className={classes['stuff']}>{card.participants_count} participants</div>
				</div>
			</div>
		</Link>
	);
};

export default LectureCard;
